export const es = {
  app: {
    stepCreate: 'Crea un quiz personalizado',
    stepShare: 'Invita a tus amigos',
    stepPlay: 'Juega',
    logoS: 'Toca la S',
  },
  footer: {
    privacy: 'Privacidad',
    terms: 'Términos',
    refunds: 'Reembolsos',
    support: 'Soporte',
    pricing: 'Precios',
    x: 'X',
    instagram: 'Instagram',
  },
  billing: {
    title: 'Planes y facturación',
    subtitle: 'Unirse a un concurso siempre es gratis. Suscríbete para crear más concursos.',
    planFree: 'Free',
    planBasic: 'Basic',
    planPremium: 'Premium',
    freeIncludes: '{n} concursos de prueba — para siempre',
    quizzesPerMonth: '{n} concursos al mes',
    perMonth: '/mes',
    currentPlan: 'Tu plan actual',
    subscribe: 'Suscribirse',
    manage: 'Gestionar suscripción',
    remainingMonthly: 'Te quedan {n} de {limit} concursos este mes',
    remainingFree: 'Te quedan {n} de {limit} concursos gratis',
    paymentSuccess: '¡Pago realizado! Tu plan ya está activo.',
    paymentActivating: 'Pago recibido — activando tu plan…',
    paymentCancelled: 'Pago cancelado. No se realizó ningún cargo.',
    signInFirst: 'Inicia sesión con Google para suscribirte.',
    checkoutError: 'No se pudo iniciar el pago. Inténtalo de nuevo.',
    backHome: 'Volver al inicio',
    quotaExceededTitle: 'Has agotado tus concursos',
    quotaExceededBody: 'Mejora tu plan para seguir creando concursos. Unirse a las partidas sigue siendo gratis.',
    seePlans: 'Ver planes',
    rematchQuotaExceeded: 'Repitiendo el mismo concurso — el anfitrión agotó su límite.',
  },
  auth: {
    signInTitle: 'Inicia sesión para crear tu concurso',
    signInHint: 'Solo el anfitrión necesita una cuenta. Tus invitados se unen con tu enlace — no hace falta iniciar sesión.',
    signInGoogle: 'Continuar con Google',
    signInError: 'No se pudo iniciar sesión. Inténtalo de nuevo.',
    signedInAs: 'Sesión iniciada como {email}',
    signOut: 'Cerrar sesión',
    downloadIosApp: 'Descargar app para iOS',
    loading: 'Cargando…',
  },
  lang: {
    label: 'Idioma',
    en: 'English',
    ru: 'Русский',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    ar: 'العربية',
  },
  setup: {
    title: 'Configuración necesaria antes de jugar',
    step1: 'Copia .env.local.example a .env.local',
    step2: 'Completa tu URL de Supabase y la clave anónima',
    step3: 'Añade tu clave de API de OpenAI',
    step4: 'Ejecuta supabase/schema.sql en el editor SQL de Supabase',
    step5: 'Reinicia el servidor de desarrollo',
  },
  create: {
    topic: 'Tema',
    topicPlaceholder: 'p. ej. dibujos de los 90, ciencia, fútbol',
    difficulty: 'Dificultad',
    difficultyEasy: 'Fácil',
    difficultyMedium: 'Media',
    difficultyHard: 'Difícil',
    questions: 'Número de preguntas',
    modeTitle: 'Modo de juego',
    modeRegular: 'Cuenta cada respuesta',
    modeRegularHint: 'Responde de inmediato. Puedes cambiar tu elección hasta que acabe el tiempo, que nunca se reduce — todos los que aciertan puntúan. La ronda termina antes solo si responden todos.',
    modeHardcore: 'Solo cuenta la primera respuesta',
    modeHardcoreHint: 'Solo puntúa la primera respuesta correcta. Tu respuesta se bloquea al enviarla — no se puede cambiar y la voz tiene un solo intento. Las respuestas se ordenan por un reloj sincronizado, así que una conexión más rápida apenas influye.',
    answerTime: 'Tiempo para responder (segundos)',
    mcTitle: 'Opción múltiple',
    mcHint: 'Cuatro opciones por pregunta — todos eligen, cada respuesta correcta suma puntos',
    cameraTitle: 'Cámaras de jugadores',
    cameraHint: 'Desactivado = solo audio (los micrófonos siguen funcionando). Activado = todos comparten vídeo.',
    submit: 'Crear concurso',
    generating: 'Generando preguntas',
    errorEmptyTopic: 'Introduce un tema.',
    errorGenerate: 'No se pudieron generar las preguntas.',
    errorCreate: 'No se pudo crear el juego en la base de datos.',
    errorGeneric: 'Algo salió mal.',
    createdTitle: 'Concurso creado',
    createdHint: 'Comparte este enlace con hasta 5 amigos y luego entra al concurso.',
    shareLink: 'Enlace para compartir',
    copy: 'Copiar',
    copied: 'Copiado',
    enterQuiz: 'Entrar al concurso',
    adjustShow: 'Más',
    adjustHide: 'Ocultar',
    browseOpenGames: 'Explorar partidas abiertas',
    browseOpenGamesHint: 'Únete a un quiz que espera jugadores',
    inviteOnlyTitle: 'Solo por enlace',
    inviteOnlyHintOn: 'Solo pueden unirse quienes tengan tu enlace. No aparece en la lista pública.',
    inviteOnlyHintOff: 'Visible en partidas abiertas hasta que empieces el quiz.',
  },
  rooms: {
    title: 'Partidas abiertas',
    empty: 'No hay partidas abiertas ahora.',
    refresh: 'Actualizar',
    join: 'Unirse',
    back: 'Atrás',
    loading: 'Cargando…',
    error: 'No se pudieron cargar las partidas.',
    players: '{n}/{max}',
    agoMinutes: 'hace {n} min',
    agoHours: 'hace {n} h',
    agoJustNow: 'Ahora mismo',
    modeRegular: 'Cuenta cada respuesta',
    modeHardcore: 'Solo cuenta la primera',
    mc: 'Opción múltiple',
    voice: 'Voz',
  },
  join: {
    title: 'Unirse al concurso',
    hostTitle: 'Eres el anfitrión',
    subtitle: 'Elige un nombre para que todos vean tu puntuación.',
    namePlaceholder: 'Tu nombre',
    button: 'Unirse',
    joining: 'Uniéndose…',
    full: 'Esta partida está llena (hasta 6 jugadores).',
    errorEmptyName: 'Introduce tu nombre.',
    banned: 'No puedes volver a unirte a esta partida.',
  },
  lobby: {
    title: 'Sala de espera',
    players: 'Jugadores',
    playersCount: '{n} / {max} jugadores',
    you: 'tú',
    host: 'Anfitrión',
    shareInvite: 'Comparte este enlace para invitar jugadores (hasta 6 en total)',
    waitingHost: 'Esperando a que el anfitrión comience…',
    needMore: 'Esperando al menos un jugador más…',
    start: 'Iniciar concurso',
    removePlayer: 'Quitar',
    removeConfirm: '¿Quitar a {name} de esta partida?',
    removeConfirmYes: 'Quitar',
    removeConfirmNo: 'Cancelar',
    removeError: 'No se pudo quitar al jugador.',
    listedPublicly: 'Visible en la lista hasta que empieces.',
  },
  game: {
    joining: 'Uniéndose a la partida',
    notFound: 'Partida no encontrada',
    notFoundHint: 'Comprueba el enlace e inténtalo de nuevo. Si eres el anfitrión, crea una partida nueva.',
    backHome: 'Volver al inicio',
    removedTitle: 'Te han expulsado',
    removedBody: 'El anfitrión te ha quitado de esta partida.',
    removedHome: 'Volver al inicio',
    host: 'Anfitrión',
    guest: 'Invitado',
    live: 'En vivo',
    offline: 'Desconectado',
    waitingCamera: 'Esperando cámara',
    cameraErrorPermission: 'Cámara/mic bloqueados. Permite el acceso a este sitio y toca aquí.',
    cameraErrorInsecure: 'La cámara necesita un enlace seguro (HTTPS).',
    cameraErrorNotFound: 'No se encontró cámara o micrófono. Toca para reintentar.',
    cameraErrorBusy: 'Cámara/mic en uso por otra app. Toca para reintentar.',
    cameraErrorUnknown: 'No se pudo acceder a la cámara/mic. Toca para reintentar.',
    cameraErrorTap: 'Toca para permitir',
    answering: 'Respondiendo',
    topic: 'Tema',
    question: 'Pregunta',
    stealChance: 'Oportunidad de robar',
    getReady: 'Prepárate',
    thinkHint: 'Lee la pregunta — la respuesta se desbloquea para ambos a la vez',
    answerNow: 'Responde ahora',
    tileAnswered: 'Respondió',
    tileThinking: 'Pensando…',
    youAnswering: 'Estás respondiendo',
    listeningAnswer: 'Escuchando respuesta',
    checkingAnswer: 'Comprobando respuestas',
    speakNow: 'Habla ahora',
    theySpeaking: 'Están hablando',
    secondsLeft: 'Quedan {n}s',
    opponentSteal: 'El rival puede robar esta',
    liveAnswer: 'Respuesta en vivo',
    correctAnswer: 'Respuesta correcta',
    speakAnswerNow: 'Di tu respuesta ahora',
    speakHint: 'Ambos responden en voz alta — la primera respuesta correcta gana',
    yourAnswer: 'Tu respuesta',
    startSpeaking: 'Empieza a decir tu respuesta…',
    holdToAnswer: 'Mantén pulsado para responder',
    recording: 'Grabando… suelta para enviar',
    listening: 'Escuchando…',
    holdHint: 'Mantén el botón y di tu respuesta',
    saidNothing: 'Sin respuesta',
    done: 'Listo',
    doneOptional: 'Confirmar ahora (opcional)',
    autoSubmitHint: 'Tu respuesta hablada se guarda automáticamente — no hace falta pulsar nada.',
    answerLockedIn: 'Respuesta confirmada',
    waitingOpponent: 'Esperando al otro jugador…',
    typeYourAnswer: 'Escribe tu respuesta abajo',
    typePlaceholder: 'O escribe tu respuesta aquí',
    waitShareLink: 'Comparte el enlace con tu rival para empezar',
    waitHostStart: 'Esperando a que el anfitrión comience',
    bothIn: 'Ambos jugadores están dentro',
    questionsCount: '{n} preguntas',
    modeMc: 'Opción múltiple',
    modeVoice: 'Di tu respuesta',
    startQuiz: 'Iniciar concurso',
    youreIn: 'Estás dentro',
    waitHostStartOverlay: 'Esperando a que el anfitrión comience',
    waitOpponent: 'Esperando a que se una tu rival',
    connecting: 'Conectando a la partida',
    pointsMultiplier: '(×{n})',
  },
  buzz: {
    label: 'Buzz',
    tapFirst: 'Toca para responder primero',
    youBuzzed: 'Pulsaste, empieza a hablar',
    otherAnswering: 'El otro jugador está respondiendo',
    ariaBuzz: 'Pulsar para responder',
    ariaDisabled: 'Buzz no disponible',
  },
  diag: {
    connected: 'Conectado',
    connecting: 'Conectando…',
    micOff: 'No se detectó micrófono',
    micStalled: 'No entra audio',
    micActive: 'Micrófono activo',
    micIdle: 'Micrófono silenciado',
    cameraOff: 'Sin cámara',
  },
  ptt: {
    hold: 'Mantén para hablar',
    talking: 'Hablando…',
    answerLive: 'Micrófono activo',
  },
  mc: {
    opponentSteal: 'El rival puede robar esta',
    answerLocked: 'Respuesta confirmada',
    canChange: 'Aún puedes cambiar',
    someoneAnswered: 'Alguien respondió — ¡{n}s para responder!',
    you: 'Tú',
  },
  score: {
    vs: 'VS',
    streak: 'racha de {n}',
    leaderboard: 'Puntuación',
    points: 'pts',
  },
  winner: {
    result: 'Resultado',
    winner: 'Ganador',
    winners: 'Ganadores',
    tie: 'Empate',
    finalScores: 'Puntuación final',
    downloadClips: 'Descargar clips de respuestas',
    clipLabel: 'P{n} · respuesta de {role}',
    download: 'Descargar',
    rematch: 'Revancha',
    rematchWaiting: 'Esperando a los demás…',
    waitRematch: 'Esperando a que el anfitrión inicie la revancha',
    exit: 'Salir',
    discuss: 'Comenta los resultados — la llamada termina en {n}s',
    discussHint: 'Cámara y micrófono apagados. Reinicia para volver a llamar.',
  },
} as const;
